<template>
  <div v-if="isVisible">
    <div class="modal" :style="dStyle" tabindex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-scrollable" :class="modalSize" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show" :style="bdStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'dt-modal',
  props: ['value', 'modalSize', 'dStyle', 'bdStyle'],
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
.modal {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/modal/dt-modal.vue